function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { ChartLine } from '../';
import moment from 'moment';
import "moment/locale/nb";
import "moment/locale/nn";
import "moment/locale/sv";
import { gaTimeDimensions, getLabelFromProps } from "../../resources/functions/";
import { FormatMetric, FormatDimension } from "../";
import Tooltip from "./ChartTooltip";

class TooltipBar extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getLabel", (id, data) => {
      const tooltipLabel = this.props.tooltipLabel;
      let labels = []; // label from tooltipLabel        

      if (tooltipLabel) {
        return getLabelFromProps(_extends({}, data, {
          label: tooltipLabel
        }));
      } // label from id


      const identifiers = id.split('/');
      identifiers.map(key => {
        const keyParts = key.split(':');

        if (keyParts[0] === "startDate" || keyParts[0] === "endDate") {
          return;
        }

        if (gaTimeDimensions.includes(key)) {
          return;
        }

        labels.push(key);
      });
      return labels.join(' ');
    });

    _defineProperty(this, "getGroups", (data, index) => {
      const _this$props = this.props,
            keys = _this$props.keys,
            colors = _this$props.colors;
      const points = data.points;
      const _points$ = points[0],
            x = _points$.x,
            datetime = _points$.datetime;
      const groups = keys.map((key, index) => {
        const label = this.getLabel(key, points[index]);
        return {
          key: key,
          label: label,
          value: data[key] || 0,
          color: colors[index],
          x: x,
          datetime: datetime,
          data: points[index]
        };
      });
      return groups;
    });

    _defineProperty(this, "renderLabel", (name, index) => {
      return React.createElement("i", {
        className: "admin-tooltip__label"
      }, React.createElement(FormatMetric, {
        name: name,
        key: index
      }));
    });

    _defineProperty(this, "renderPoint", (point, index) => {
      let _this$props2 = this.props,
          dimension = _this$props2.dimension,
          metricType = _this$props2.metricType;
      const color = point.color,
            key = point.key,
            label = point.label,
            value = point.value;
      const style = {
        backgroundColor: color
      };

      if (!value) {
        return false;
      }

      return React.createElement("li", {
        key: index
      }, React.createElement("div", {
        className: "admin-tooltip__chip",
        style: style
      }), label.split(' ').map(this.renderLabel), React.createElement("i", {
        className: "admin-tooltip__value"
      }, React.createElement(FormatMetric, {
        type: metricType,
        value: value
      })));
    });

    _defineProperty(this, "renderTitle", data => {
      const _this$props3 = this.props,
            dimension = _this$props3.dimension,
            tooltipTitle = _this$props3.tooltipTitle;
      console.log('tooltipProps', data);

      if (tooltipTitle) {
        const title = getLabelFromProps(_extends({}, data, {
          label: tooltipTitle
        }));
        return React.createElement("h2", {
          className: "admin-tooltip__title"
        }, title);
      }

      const datetime = data.datetime,
            x = data.x;
      let value;

      if (dimension.startsWith('ga:nth')) {
        value = datetime;
      } else {
        value = x;
      }

      return React.createElement("h2", {
        className: "admin-tooltip__title"
      }, React.createElement(FormatDimension, {
        name: dimension,
        value: value
      }));
    });

    _defineProperty(this, "renderSeries", series => {
      return React.createElement(Tooltip, null, this.renderTitle(series[0].data), React.createElement("ul", null, series.map(this.renderPoint)));
    });
  }

  render() {
    const _this$props4 = this.props,
          groupMode = _this$props4.groupMode,
          compare = _this$props4.compare,
          dimension = _this$props4.dimension,
          bar = _this$props4.bar;
    const data = bar.data;
    console.log('DATA BAR', bar);
    const series = this.getGroups(data);
    return this.renderSeries(series);
  }

}

_defineProperty(TooltipBar, "defaultProps", {
  tooltipTitle: undefined,
  tooltipLabel: undefined
});

export default TooltipBar;